<template>
<div>
    <loading v-if="$root.loading"></loading>
    <div :class="['pager',{empty:!$parent.total}]" v-if="pages>0&&!$root.loading">
        <div class="wrap" v-if="$parent.total">
            <div class="main">
                <button class="pick sibling prev" @click="$emit('pager',xcurrentPage-1<=0?1:xcurrentPage-1)"></button>
                <button :class="['pick',{current:xcurrentPage==1}]" @click="$emit('pager',1)">1</button>
                <span v-if="xcurrentPage-6>0">...</span>
                <button :class="['pick',{current:index+1==xcurrentPage}]" @click="$emit('pager',index+1)" v-for="(item,index) in pages" v-if="abs(index+1-xcurrentPage)<3&&index!=0&&index!=pages-1" :key="index">{{index+1}}</button>
                <span v-if="xcurrentPage+4<=pages">...</span>
                <button :class="['pick',{current:xcurrentPage==pages}]" @click="$emit('pager',pages)" v-if="pages>1">{{pages}}</button>
                <button class="pick sibling next" @click="$emit('pager',xcurrentPage+1>pages?pages:xcurrentPage+1)"></button>
            </div>
            <div class="jump">
                <div>跳转到：</div>
                <input placeholder="" v-int v-model.number="page">
                <button class="pick" @click="$emit('pager',page)">GO</button>
            </div>
        </div>
        <div class="emptyData" v-else>{{$parent.ajaxStatus.getList=='listError'?'加载出错':empty}}</div>
    </div>
</div>
    
</template>
<style lang="less" scoped>
    .pager {
        display: flex;
        height: 100px;
        align-items: center;
        justify-content: center;

        .emptyData {
            width: 100%;
            display: flex;
            justify-content: center;
            color: #9ca2a6;
            font-size: 15px;
        }


        .wrap {
            display: inline-flex;
            justify-content: flex-end;
            align-items: center;
            letter-spacing: 2px;
            user-select: none;

            .main {
                font-size: 0;
                position: relative;
                display: flex;

                span {
                    font-size: 14px;
                    vertical-align: bottom;
                    padding: 0 5px;
                    color: #999;
                    width: 32px;
                    height: 32px;
                    position: relative;
                    display: flex;
                    align-items: flex-end;
                    justify-content: center;

                    input {
                        border: none;
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        left: 0;
                        top: 0;
                        text-align: center;
                        opacity: 0;
                        cursor: pointer;
                        color: #666;
                        border-bottom: 1px solid gray;

                        &:focus {
                            opacity: 1;
                            cursor: text;
                        }
                    }
                }
            }

            .pick {
                border: none;
                height: 32px;
                min-width: 32px;
                background-color: transparent;
                font-size: 14px;
                color: #666;
                transition: all .2s;
                cursor: pointer;
                vertical-align: top;
                margin: 0 3px;
                border:1px solid rgba(230,230,230,1);
                border-radius:3px;

                &:hover,
                &.current {
                    background-color: #e60012;
                    color: white;
                }

                &.sibling {
                    width: 32px;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-image: url("../assets/images/pager/arrow_left.png");

                    &:hover {
                        background-image: url("../assets/images/pager/arrow_left_white.png");
                    }
                }

                &.next {
                    transform: rotate(180deg);
                }
            }

            .sec {
                font-size: 12px;
                color: #8f8f8f;
                height: 32px;
                display: flex;
                align-items: center;
                padding-left: 10px;

                .pager-num {
                    height: 22px;
                    width: 45px;
                    border: 1px solid #ddd;
                    text-align: center;
                    color: #8f8f8f;
                    transition: all .2s;
                    margin: 0 5px;


                    &:hover,
                    &:focus {
                        border-color: #999;
                    }
                }

                .confirm {
                    padding: 0 13px;
                    height: 32px;
                    border: none;
                    background-color: transparent;
                    color: #666;
                    cursor: pointer;
                    margin-left: 5px;
                    transition: all .2s;

                    &:hover {
                        background-color: #f1f3f7;
                    }
                }
            }

            .jump {
                display: flex;
                align-items: center;
                font-size:14px;
                font-weight:400;
                color:#808080;
                font-family:Microsoft YaHei;
                margin-left: 30px;

                input {
                    width:32px;
                    height:32px;
                    border:1px solid rgba(230,230,230,1);
                    border-radius:3px;
                    margin-right: 10px;
                    padding: 0 5px;
                }
            }
        }


    }
</style>
<script>
    export default {
        props: {
            xpages: {
                default: 1
            },
            xcurrentPage: {
                default: 1
            },
            empty: {
                default: "暂无数据"
            }
        },
        data: function () {
            return {
                page: '',
                pagesArr: new Array(this.xpages)
            }
        },
        methods: {
            abs: function (v) {
                return Math.abs(v);
            }
        },
        computed: {
            pages: function () {
                return Math.max(this.xpages, this.xcurrentPage);
            }
        }
    }
</script>